import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type WouldRecommendProps = {
    wouldRecommend: boolean;
};

export const WouldRecommend = ({ wouldRecommend }: WouldRecommendProps) => {
    const { t } = useGranite();

    return wouldRecommend ? (
        <div className={cn("tw:flex tw:gap-4 tw:items-center tw:ml-1")}>
            <span
                className={cn(
                    "tw:flex tw:items-center tw:justify-center tw:w-5 tw:h-5 tw:rounded-full tw:shadow-2xs tw:bg-success tw:text-white"
                )}
            >
                <i className={cn("las la-check", "tw:text-sm")}></i>
            </span>
            <span className={cn("tw:block")}>
                {t("product.reviews.review.wouldRecommend.yes")}
            </span>
        </div>
    ) : (
        <div className={cn("tw:flex tw:gap-4 tw:items-center tw:ml-1")}>
            <span
                className={cn(
                    "tw:flex tw:items-center tw:justify-center tw:w-5 tw:h-5 tw:rounded-full tw:shadow-xs tw:bg-danger tw:text-white tw:outline"
                )}
            >
                <i className={cn("las la-times", "tw:text-sm")}> </i>
            </span>
            <span className={cn("tw:block")}>
                {t("product.reviews.review.wouldRecommend.no")}
            </span>
        </div>
    );
};
